import React from "react";
import './Strassenlaternenmastlackierung.css';
import { useNavigate } from 'react-router-dom';

const Strassenlaternenmastlackierung = () =>{

    const navigate = useNavigate();
    const handleNavigationContact = () => {
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById('contact');
          if ( element ){
            element.scrollIntoView({behavior: 'smooth'});
          }
        }, 100);
      }

    return(
        <section className="strassen-container">
            <h1 className="strassen-title">Professionelle Straßenlaternenmastlackierung</h1>
            <p className="strassen-description">
                Wir bieten professionelle Lackierarbeiten für Straßenlaternenmasten mit umfassender Erfahrung im Umgang mit Rost und Korrosion. 
                Durch den Einsatz hochwertiger Materialien und modernster Techniken gewährleisten wir einen langlebigen Schutz gegen Witterungseinflüsse.
            </p>

            <section className="strassen-steps">
                <h2>Unser Arbeitsprozess:</h2>
                <p>
                    Unser Lackierprozess ist speziell darauf ausgelegt, Straßenlaternenmasten dauerhaft zu schützen und deren Lebensdauer zu verlängern. 
                    Hier sind die einzelnen Schritte unserer Arbeit:
                </p>
                <ol>
                    <li><span className="bolded">Reinigung des Mastes: </span> Wir entfernen Schmutz, Fett und Rost mit speziellen Reinigungsgeräten.</li>
                    <li><span className="bolded">Rostbehandlung: </span> Einsatz von hochwertigen Rostschutzmitteln, um Korrosionsstellen gründlich zu behandeln.</li>
                    <li><span className="bolded">Grundierung: </span>Nach der Rostbehandlung tragen wir eine Grundierung auf, um den Mast optimal auf die Endlackierung vorzubereiten.</li>
                    <li><span className="bolded">Endlackierung: </span>Mit witterungsbeständigen Lacken wird der Mast in mehreren Schichten lackiert, um einen langanhaltenden Schutz zu gewährleisten.</li>
                </ol>
            </section>
      
            <section className="strassen-expertise">
                <h2>Unsere Expertise:</h2>
                <p>
                    Mit langjähriger Erfahrung im Bereich Korrosionsschutz und Lackierung sind wir in der Lage, die Masten effektiv vor Umwelteinflüssen zu schützen. 
                    Unser Team ist hochqualifiziert und arbeitet mit modernster Ausrüstung, um die beste Qualität zu liefern.
                </p>
            </section>

            <section className="strassen-contact">
                <p>Wenn Sie eine professionelle Lackierung Ihrer Straßenlaternenmasten wünschen oder Fragen haben, zögern Sie nicht, uns zu kontaktieren. Wir beraten Sie gerne!</p>
                <button className="contact-button" onClick={handleNavigationContact}>Kontakt aufnehmen</button>
            </section>
        </section>
    );
};

export default Strassenlaternenmastlackierung;